import React from "react";
import StepContent1 from "./StepContent1";
import StepContent2 from "./StepContent2";
import StepContent3 from "./StepContent3";
import StepContent4 from "./StepContent4";
import ProfTestWizard from "./ProfTestWizard";
const steps = [
  { id: 0, label: "Пункт 1" },
  { id: 1, label: "Пункт 2" },
  { id: 2, label: "Пункт 3" },
  { id: 3, label: "Пункт 4" }
];

const ProgressRoad = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [stepData, setStepData] = React.useState(Array(4).fill(null));

  const handlePointClick = (index) => {
    setActiveStep(index);
  };

  const handleStepComplete = (index, dataForNext) => {
    setStepData((prev) => {
      const next = [...prev];
      next[index] = dataForNext;
      return next;
    });

    if (index < steps.length - 1) {
      setActiveStep(index + 1);
    }
  };

  const renderContent = () => {
    switch (activeStep) {
      case 0:
        return React.createElement(ProfTestWizard);
      case 1:
        return React.createElement(StepContent2, {
          previousData: stepData[0],
          onNext: (data) => handleStepComplete(1, data)
        });
      case 2:
        return React.createElement(StepContent3, {
          previousData: stepData[1],
          onNext: (data) => handleStepComplete(2, data)
        });
      case 3:
      default:
        return React.createElement(StepContent4, {
          previousData: stepData[2]
        });
    }
  };

  // Человечек двигается слева направо: 0 — крайний левый пункт, 3 — крайний правый
  const walkerLeftPosition = `${activeStep * 33.33}%`;

  return React.createElement(
    "div",
    { className: "road-wrapper container" },
    React.createElement("h1", { className: "road-title" }, "Трекер- дорога из 4 пунктов"),
    React.createElement(
      "div",
      { className: "road-container" },
      React.createElement(
        "svg",
        {
          className: "road-line",
          viewBox: "0 0 100 20",
          preserveAspectRatio: "none"
        },
        React.createElement(
          "defs",
          null,
          React.createElement(
            "linearGradient",
            {
              id: "roadGradient",
              x1: "0%",
              y1: "0%",
              x2: "100%",
              y2: "0%"
            },
            React.createElement("stop", {
              offset: "0%",
              stopColor: "#4c8dff"
            }),
            React.createElement("stop", {
              offset: "100%",
              stopColor: "#8f5cff"
            })
          )
        ),
        React.createElement("path", {
          d: "M0 15 Q 12.5 5 25 15 T 50 15 T 75 15 T 100 15",
          fill: "none",
          stroke: "url(#roadGradient)",
          strokeWidth: "3",
          strokeLinecap: "round"
        })
      ),
      React.createElement(
        "div",
        {
          className: "road-walker",
          style: { left: walkerLeftPosition }
        },
        React.createElement("div", { className: "walker-body" })
      ),
      React.createElement(
        "div",
        { className: "road-points" },
        steps.map((step, index) =>
          React.createElement(
            "button",
            {
              key: step.id,
              type: "button",
              className: `road-point ${activeStep === index ? "active" : ""}`,
              onClick: () => handlePointClick(index)
            },
            React.createElement(
              "span",
              { className: "road-point-index" },
              index + 1
            ),
            React.createElement(
              "span",
              { className: "road-point-label" },
              step.label
            )
          )
        )
      )
    ),
    React.createElement(
      "div",
      { className: "road-content" },
      renderContent()
    )
  );
};

export default ProgressRoad;


